export const pickupData = [
  {
    id: 1,
    state: "Accra",
    terminal: "Accra",
    location: [
      "Shell filling station, Tema Motorway, roundabout, Tema, Accra.",
      "25 Mall, Tema Motor way",
      "Methodist Junction, Dawenya.",
    ],
  },
];
